/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import MoveToAnotherTreatment from 'DesignSystem/MoveToAnotherTreatment/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/More/MoveToAnotherTreatment/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: '_id',
})
let tabTreatmentCardIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'treatment_card_id',
})
let eventAppointmentIdValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'appointment._id',
format: fromFormat.asList,
})
  return (<React.Fragment
>
<MoveToAnotherTreatment
  viewPath={`${viewPath}/MoveToAnotherTreatment`}
 data="patient._id"
 patient_id={patientIdValueData}
 data="tab.treatment_card_id"
 treatment_card_id={tabTreatmentCardIdValueData}
 data="event.appointment._id"
 format="/Data/format.js asList"
 appointment_ids={eventAppointmentIdValueData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
/>
{children}
</React.Fragment>)
}